export enum IconEnum {
  BairesDev = 'BairesDev',
  DedicatedTeams = 'DedicatedTeams',
  StaffAugmentation = 'StaffAugmentation',
  SoftwareOutsourcing = 'SoftwareOutsourcing',
}

type IconType = keyof typeof IconEnum;

type Maybe<T> = T | null;

export default interface MenuItem {
  id: string;
  path: string;
  label: string;
  description?: string;
  icon?: IconType;
  children: MenuItem[];
  rel?: Maybe<string> | undefined;
}

export interface NewMenuItemSection {
  id: string;
  title: string | null;
  description: string | null;
  links: {
    id: string;
    link_label: string;
    link_url: string;
  }[];
}

export interface NewMenuItemExtraContent {
  client: {
    data: {
      id: string;
      attributes: {
        client_name: string;
        client_logos: {
          color_logo: {
            data: {
              id: string;
              attributes: {
                url: string;
              };
            };
          };
        };
      };
    } | null;
  };
  image: {
    data: {
      attributes: {
        alternativeText: string | null;
        url: string;
      };
    } | null;
  };
  content: string;
}

export interface NewMenuItem {
  id: string;
  title: string;
  url: string | null;
  sections: NewMenuItemSection[];
  cta: {
    link_label: string;
    link_url: string;
  } | null;
  extraContent: NewMenuItemExtraContent | null;
}
